(function () {
  const POLL_INTERVAL_MS = 120;
  const POLL_MAX_MS = 8000;
  const RELABEL_ATTR = 'data-divano-relabeled-original';

  function readManifest() {
    const scripts = document.querySelectorAll(
      'script[type="application/json"][data-divano-availability-manifest]'
    );
    for (const s of scripts) {
      try {
        const data = JSON.parse(s.textContent || '{}');
        if (data && data.variants) {
          return { data, productId: s.dataset.productId, labels: data.labels || {} };
        }
      } catch (err) {
      }
    }
    return null;
  }

  function getCurrentVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return input.value;
    const url = new URL(window.location.href);
    return url.searchParams.get('variant');
  }

  function deriveState(manifest, variantId) {
    if (!manifest || !variantId) return null;
    const v = manifest.data.variants[String(variantId)];
    if (!v) return null;
    if (v.lead_time_state) return v.lead_time_state;
    const productDefault = manifest.data.product_defaults && manifest.data.product_defaults.lead_time_state;
    if (productDefault) return productDefault;
    if (v.is_made_to_order) return 'preorder';
    if (v.bridge_state) return v.bridge_state;
    return null;
  }

  function findBuyItNowButtonIn(root) {
    if (!root) return null;
    const buttons = root.querySelectorAll('button, [role="button"]');
    for (const b of buttons) {
      const text = (b.textContent || '').trim().toLowerCase();
      if (/buy\s*it\s*now|buy\s*now/.test(text)) return b;
      if (b.hasAttribute(RELABEL_ATTR)) return b;
    }
    return null;
  }

  function findAllBuyItNowButtons() {
    const buttons = [];
    const hosts = document.querySelectorAll('shopify-accelerated-checkout');
    for (const host of hosts) {
      let btn = findBuyItNowButtonIn(host);
      if (btn) {
        buttons.push(btn);
        continue;
      }
      if (host.shadowRoot) {
        btn = findBuyItNowButtonIn(host.shadowRoot);
        if (btn) buttons.push(btn);
      }
    }
    return buttons;
  }

  function findBuyItNowButton() {
    const all = findAllBuyItNowButtons();
    return all.length > 0 ? all[0] : null;
  }

  function firstNonEmptyTextNode(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        return n.nodeValue && n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    return walker.nextNode();
  }

  function relabel(button, newLabel) {
    if (!button) return;
    const textNode = firstNonEmptyTextNode(button);
    if (!textNode) return;
    if (!button.hasAttribute(RELABEL_ATTR)) {
      button.setAttribute(RELABEL_ATTR, textNode.nodeValue);
    }
    textNode.nodeValue = newLabel;
  }

  function restoreOriginal(button) {
    if (!button || !button.hasAttribute(RELABEL_ATTR)) return;
    const original = button.getAttribute(RELABEL_ATTR);
    const textNode = firstNonEmptyTextNode(button);
    if (textNode) textNode.nodeValue = original;
    button.removeAttribute(RELABEL_ATTR);
  }

  function update() {
    const manifest = readManifest();
    if (!manifest) return;
    const variantId = getCurrentVariantId();
    const state = deriveState(manifest, variantId);
    const buttons = findAllBuyItNowButtons();
    if (buttons.length === 0) return;
    for (const button of buttons) {
      if (state === 'preorder') {
        const preorderLabel = (manifest.labels && manifest.labels.preorder_now)
          || button.getAttribute('data-divano-preorder-label')
          || 'Preorder Now';
        relabel(button, preorderLabel);
      } else {
        restoreOriginal(button);
      }
    }
  }

  function pollUntilFound(deadline) {
    if (Date.now() > deadline) return;
    const buttons = findAllBuyItNowButtons();
    if (buttons.length > 0) {
      update();
      if (Date.now() < deadline) {
        setTimeout(() => pollUntilFound(deadline), POLL_INTERVAL_MS);
      }
      return;
    }
    setTimeout(() => pollUntilFound(deadline), POLL_INTERVAL_MS);
  }

  function init() {
    pollUntilFound(Date.now() + POLL_MAX_MS);

    document.addEventListener('variant:update', () => {
      setTimeout(() => pollUntilFound(Date.now() + POLL_MAX_MS), 50);
    });

    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input) {
      input.addEventListener('change', () => setTimeout(update, 50));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
